// extracted by mini-css-extract-plugin
module.exports = {"container":"ChromeExtensionWidget_container__iIdia","text":"ChromeExtensionWidget_text__iw_00","link":"ChromeExtensionWidget_link__5aQmQ"};